export default {
  postoneFileUpload: "/api/v1/system/sysFile/oneFileUpload",
};
